<template>
  <div class="col messages full-width items-center">
    <q-spinner-ios
      v-once
      color="primary"
      size="3em"
      v-if="isLoading"
    />

    <q-virtual-scroll
      v-else
      style="height: 300px; max-height: 300px; width: 100%"
      class="column full-width"
      :items="messages"
    >
      <template #default="{ item }">
        <AttendanceMailItem
          :key="item.id"
          :message="item"
          :is-history-email="true"
        />
      </template>
    </q-virtual-scroll>
  </div>
</template>

<script>
import api from '@/libs/api'
import moment from 'moment-timezone'
import { prepareBody, parseJSON } from '@/store/modules/attendanceModule.js'
import AttendanceMailItem from '@/components/AttendanceMailItem'

export default {
  props: {
    attendanceId: {}
  },
  components: {
    AttendanceMailItem
  },

  data () {
    return {
      isLoading: true,
      messages: []
    }
  },
  mounted () {
    this.loadMessages()
  },

  methods: {
    async loadMessages () {
      this.messages = await api.loadEmailMessages(this.attendanceId)
        .then(({ messages }) => messages.reverse().map((msg) => {
          const status = getStatus(msg)
          return { ...handlerMsg(msg), status }
        }))
      this.isLoading = false
    }
  }
}
const handlerMsg = (email) => {
  const mailTo = parseJSON(email.mailTo, [])
  const createdAt = moment(email.serverDatetimeAt).unix()
  const fromContent = email.mailFrom ? email.mailFrom : (email.agentName ? `Agente ${email.agentName} #${email.agentId}` : '')
  const directionLabel = email.direction === 'IN' ? 'Mensagem Recebida' : 'Mensagem Enviada'
  const startContent = `<i><b>${directionLabel}</b><br>${fromContent ? `De: ${fromContent}<br>` : ''}Data: ${moment.unix(createdAt).format('DD/MM/YY HH:mm:ss')}<br>Para: ${mailTo.map(({ id }) => id).join(', ')}<br>Disse:<br></i>`
  const htmlStr = prepareBody(email)
  const mailBody = `<div>${startContent}<blockquote>${htmlStr}</blockquote></div>`
  const isOut = email.direction === 'OUT'
  const replyTo = isOut ? email.mailTo : email.replyTo

  const cc = parseJSON(email.mailCc, []).map(({ id, label }) => ({ id, label: label || id }))
  const attachments = Array.isArray(email.mailAttachments) ? email.mailAttachments : parseJSON(email.mailAttachments, [])
  let to = parseJSON(replyTo, []).map(({ id, label }) => ({ id, label: label || id }))
  if (!to.length) to = [{ id: email.mailFrom, label: email.mailFrom }]

  email.to = to
  email.cc = cc
  email.mailBody = mailBody
  email.createdAt = createdAt
  email.attachments = attachments
  email.directionLabel = directionLabel
  return email
}

const getStatus = (msg) => {
  const isIn = msg.direction === 'IN'
  const label = isIn ? 'Cliente' : 'Agente'
  const mDate = moment(msg.serverDatetimeAt).unix()
  const isToday = moment.unix(mDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
  const dateFormated = isToday ? moment.unix(mDate).format('[às] HH:mm') : moment.unix(mDate).format('[em] DD/MM/YY [às] HH:mm')

  return `${label} ${dateFormated}`.trim()
}

</script>

<style lang="sass">

  .messages
    .q-virtual-scroll__content
      width: 100%

  .img
    max-width: 100%
    height: auto
</style>
